import { Selector } from 'reselect'

import {
  GlobalLoadingProps,
} from '../../../types/frontend/app'

import {
  RootState,
} from '../../../types/frontend/store_generic'

export const globalLoading: Selector<RootState, GlobalLoadingProps> = (state) => state.network.globalLoading

export default {
  globalLoading,
}